// RUBRIC-BASED AI interview — the parts of a library → screening copy that only
// apply to question banks. The server picks each session's questions from the
// banks, so the copy carries the banks and no flat question list.
// Standard lives in ./standard.js.

export const TYPE = 'rubric-based';

export function isRubricTemplate(template) {
  return (
    template?.advancedType === TYPE && Array.isArray(template?.rubrics) && template.rubrics.length > 0
  );
}

export function buildQuestionFields(template) {
  const rubrics = template.rubrics;
  return {
    questions: [],
    rubrics,
    // Questions a session will ask: the pick per bank, capped by the bank size.
    maxQuestions: rubrics.reduce(
      (sum, r) => sum + Math.min(r.questionsPerInterview || 1, (r.questionBank || []).length),
      0
    ),
  };
}

export function hasQuestions(template) {
  return isRubricTemplate(template);
}
